module.exports = __webpack_public_path__ + "static/img/login01_08.ce6fd23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login01_08.png
// module id = j6QV
// module chunks = 0